import { BaseAPI, Configuration, type ConfigurationParameters } from "api";
import { useMemo } from "react";

export function useApi<T extends typeof BaseAPI>(
  type: T,
  params?: Partial<ConfigurationParameters>,
) {
  const api = useMemo(() => {
    const config = new Configuration({
      ...params,
      basePath: window.location.origin,
    });

    return new type(config);
  }, [params, type]);

  return api as InstanceType<T>;
}
